import axios from 'axios';

export type GetSearchFilesResponse = {
  id: string | undefined;
  name: string;
  filetype: string;
  folder: string;
  parent: string | undefined;
  url: string | undefined;
  user: string;
}[];

export const files = async (params: { input?: string }) => {
  const { data } = await axios.get<GetSearchFilesResponse>('/search/files', {
    params,
  });
  return data;
};
